import React from 'react';

const LOGO_URL = 'https://media-manager-c.questera.ai/greta-media/64b6f00450a2ccd8585f32418c01e01155b9a46657aed859be5d908803e7074989df043f4ede815d2dc0fa021038408b/images/aW1hZ2UvanBlZw==/8bc959e50b71ba15f8f48dcf2f7551a3.jpg';

export default function Logo({size = 'md'}) {
  const large = size === 'lg';

  return (
    <span className="inline-flex items-center gap-1">
      <span className={`${large ? 'h-12 w-12' : 'h-10 w-10 sm:h-12 sm:w-12'} flex shrink-0 items-center justify-center overflow-hidden rounded-[30%] bg-white p-1 shadow-sm ring-1 ring-white/20`}>
        <img src={LOGO_URL} alt="" className="h-full w-full object-contain" />
      </span>
      <span className={`${large ? 'text-xl sm:text-2xl' : 'text-lg sm:text-xl'} whitespace-nowrap rounded-lg bg-[#0b1423] px-2 py-1.5 font-extrabold leading-none tracking-tight`}>
        <span className="text-white">Jelly</span>{' '}
        <span className="text-[#3fc0fa]">Local</span>
      </span>
    </span>
  );
}